export default (pageLength) => ({
    data: () => ({
        currentPage: 1,
    }),
    computed: {
        pageCount() {
            return Math.ceil(this.list.length / pageLength);
        },
        pageObjects() {
            return this.list.slice((this.currentPage - 1) * pageLength, this.currentPage * pageLength)
        },
    }
})